import { create, enforce, test } from "vest";

export default create((data = {}) => {
  test("corporateName", () => {
    enforce(data.corporateName)
      .isNotNull()
      .message("Corporate name is required")
      .isNotBlank();
  });
});
